import { render } from "./IconCheckParent.vue?vue&type=template&id=07e17d23"
import script from "./IconCheckParent.vue?vue&type=script&lang=ts"
export * from "./IconCheckParent.vue?vue&type=script&lang=ts"
script.render = render

export default script